import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  HStack,
  Box,
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
// Removed illustrative icons per request
import { statusColors } from '../../themes/components/tag'

interface CreateOptionsModalProps {
  isOpen: boolean
  onClose: () => void
  onSelectOption: (option: string) => void
}

const CreateOptionsModal: React.FC<CreateOptionsModalProps> = ({
  isOpen,
  onClose,
  onSelectOption,
}) => {
  const { t } = useTranslation()
  const handleOptionClick = (option: string) => {
    onSelectOption(option)
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(4px)" />
      <ModalContent minH="280px" borderRadius="16px" boxShadow="0 8px 32px rgba(0,0,0,0.12)">
        <ModalHeader pt="32px" pb="24px">
          <Box display="flex" justifyContent="center" alignItems="center">
            <Text fontSize="20px" fontWeight="700" color="solid.900" textAlign="center">
              {t('content.modals.createOptions.title')}
            </Text>
          </Box>
        </ModalHeader>
        <ModalCloseButton
          top="20px"
          right="20px"
          sx={{
            border: 'none',
            bg: 'transparent',
            _hover: { bg: 'solid.25', borderRadius: '6px' },
            _focus: { outline: 'none', boxShadow: 'none', border: 'none' },
          }}
        />
        <ModalBody py="24px" px="32px">
          <HStack spacing="16px" justify="center"  flexWrap="wrap">
            <Box
              width="160px"
              height="160px"
              bg="solid.0"
              borderRadius="12px"
              border="2px solid"
              borderColor="solid.100"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              cursor="pointer"
              transition="all 0.2s"
              position="relative"
              gap="12px"
              _hover={{
                transform: 'translateY(-4px)',
                borderColor: statusColors.error.border,
                bg: statusColors.error.bg,
                boxShadow: '0 8px 16px rgba(0,0,0,0.08)',
              }}
              onClick={() => handleOptionClick('learning')}
            >
              <Text fontSize="16px" fontWeight="700" color="solid.900" _hover={{ color: statusColors.error.color }}>
                {t('content.types.learning')}
              </Text>
              <Text fontSize="12px" color="solid.500" textAlign="center" px="12px">
                External courses
              </Text>
            </Box>

            <Box
              width="160px"
              height="160px"
              bg="solid.0"
              borderRadius="12px"
              border="2px solid"
              borderColor="solid.100"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              cursor="pointer"
              transition="all 0.2s"
              position="relative"
              gap="12px"
              _hover={{
                transform: 'translateY(-4px)',
                borderColor: statusColors.warning.border,
                bg: statusColors.warning.bg,
                boxShadow: '0 8px 16px rgba(0,0,0,0.08)',
              }}
              onClick={() => handleOptionClick('content')}
            >
              <Text fontSize="16px" fontWeight="700" color="solid.900" _hover={{ color: statusColors.warning.color }}>
                {t('content.modals.createOptions.options.content')}
              </Text>
              <Text fontSize="12px" color="solid.500" textAlign="center" px="12px">
                Skills & tasks
              </Text>
            </Box>

            <Box
              width="160px"
              height="160px"
              bg="solid.0"
              borderRadius="12px"
              border="2px solid"
              borderColor="solid.100"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              cursor="pointer"
              transition="all 0.2s"
              position="relative"
              gap="12px"
              _hover={{
                transform: 'translateY(-4px)',
                borderColor: statusColors.success.border,
                bg: statusColors.success.bg,
                boxShadow: '0 8px 16px rgba(0,0,0,0.08)',
              }}
              onClick={() => handleOptionClick('survey')}
            >
              <Text fontSize="16px" fontWeight="700" color="solid.900" _hover={{ color: statusColors.success.color }}>
                {t('content.types.survey')}
              </Text>
              <Text fontSize="12px" color="solid.500" textAlign="center" px="12px">
                Collect feedback
              </Text>
            </Box>
          </HStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default CreateOptionsModal